import { apiAction } from 'actions/application'
import { getRulesUtilsData } from 'services/dash'
import { pageErrorHandler } from 'sagas/errorHandlers'

export const RULES_UTILS_FETCH_REQUEST = 'RULES_UTILS_FETCH_REQUEST'
export const RULES_UTILS_FETCH_SUCCESS = 'RULES_UTILS_FETCH_SUCCESS'
export const RULES_UTILS_FETCH_FAILURE = 'RULES_UTILS_FETCH_FAILURE'

/**
 * Fetch dashboard + blacklist data for the RulesUtils developer tool.
 * The `getRulesUtilsData` service function chains both API calls internally
 * so that the combined result is available as a single response.
 *
 * On success, `RULES_UTILS_FETCH_SUCCESS` is dispatched and the data is
 * stored in the `rulesUtils` reducer for the component to read via selector.
 * On failure, `pageErrorHandler` suppresses the global ErrorModal so the
 * component's own inline error state (getHasRulesUtilsError) is the sole
 * feedback path — same pattern as requestRecentlyViewedData and other
 * read-only page fetches in this codebase.
 *
 * @param {string} serialNumber
 */
export const fetchRulesUtilsData = (serialNumber) =>
  apiAction({
    asyncFn: getRulesUtilsData,
    args: { serialNumber },
    successActionType: RULES_UTILS_FETCH_SUCCESS,
    failureActionType: RULES_UTILS_FETCH_FAILURE,
    requestActionType: RULES_UTILS_FETCH_REQUEST,
    id: serialNumber,
    // Suppress the global ErrorModal on failure — RulesUtils.jsx renders its
    // own inline error state via getHasRulesUtilsError. Without this, a failed
    // fetch would show both the inline error AND a blocking global modal.
    errorHandlers: [pageErrorHandler],
  })
